import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Calendar, PhoneCall, ChevronUp, ChevronDown } from "lucide-react";

export default function StickyCTA() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden pointer-events-none">
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop Filter */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
              className="fixed inset-0 bg-[#000000]/60 backdrop-blur-sm pointer-events-auto"
            />

            {/* Slide-Up Panel */}
            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 280 }}
              className="bg-[#0B0B0B] border-t border-[#FF8C00]/25 rounded-t-2xl p-6 relative pointer-events-auto flex flex-col gap-4 shadow-[0_-10px_30px_rgba(0,0,0,0.8)] text-[#F6F4EE]"
              data-testid="mobile-sticky-cta-panel"
            >
              <div className="w-12 h-1 bg-[#FF8C00]/40 rounded-full mx-auto mb-2" />
              <h4 className="font-serif text-[#F6F4EE] text-center text-lg font-medium">
                Start Your ESHA Journey
              </h4>
              <p className="text-xs text-[#AAA29E] text-center mb-2">
                Choose the best first step that resonates with your current state.
              </p>

              <a
                href="https://learn.eshawitheswari.com/l/96a7c7eae0"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-between p-4 bg-gradient-to-r from-[#FF8C00] to-[#FF4500] text-[#FDFDFB] text-sm uppercase tracking-wider font-mono font-bold rounded-xl shadow-md"
                data-testid="mobile-sticky-cta-masterclass"
              >
                <span className="flex items-center gap-2">
                  <Sparkles className="h-4 w-4" />
                  Attend Masterclass
                </span>
                <span className="text-[10px] bg-black/10 px-2 py-0.5 rounded">Checkout</span>
              </a>

              <a
                href="https://learn.eshawitheswari.com/web/lite/events/6a48df41599e3232f7dee506"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full flex items-center justify-between p-4 bg-[#0B0B0B] border border-[#FF8C00]/25 text-[#F6F4EE] text-sm uppercase tracking-wider font-mono font-bold rounded-xl"
                data-testid="mobile-sticky-cta-clarity-call"
              >
                <span className="flex items-center gap-2">
                  <PhoneCall className="h-4 w-4 text-[#00D2FF]" />
                  Book a Clarity Call
                </span>
                <span className="text-[10px] text-[#00D2FF]">Apply Now</span>
              </a>

              <Link
                to="/offerings"
                onClick={() => setIsOpen(false)}
                className="w-full flex items-center justify-between p-4 bg-[#0B0B0B] border border-[#FF8C00]/15 text-[#AAA29E] text-sm uppercase tracking-wider font-mono font-bold rounded-xl"
                data-testid="mobile-sticky-cta-calendar"
              >
                <span className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-[#FF8C00]" />
                  Explore ESHA Offerings Hub
                </span>
                <span className="text-[10px] text-[#00D2FF]">View Store</span>
              </Link>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Persistent Button */}
      <div className="p-4 w-full flex justify-center pointer-events-auto">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="bg-[#0B0B0B] border border-[#FF8C00]/35 text-[#F6F4EE] font-mono text-xs uppercase tracking-widest px-8 py-3.5 rounded-full flex items-center gap-2.5 shadow-[0_10px_25px_rgba(0,0,0,0.8)] hover:scale-105 active:scale-95 transition-all w-11/12 max-w-sm justify-between"
          data-testid="mobile-sticky-trigger-button"
        >
          <span className="flex items-center gap-2 font-bold text-[#00D2FF]">
            <Sparkles className="h-3.5 w-3.5 animate-pulse" />
            Start Your ESHA Journey
          </span>
          {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
        </button>
      </div>
    </div>
  );
}
